import { render, staticRenderFns } from "./team-list-transfer.vue?vue&type=template&id=4893637e&scoped=true&"
import script from "./team-list-transfer.vue?vue&type=script&lang=js&"
export * from "./team-list-transfer.vue?vue&type=script&lang=js&"
import style0 from "./team-list-transfer.vue?vue&type=style&index=0&id=4893637e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4893637e",
  null
  
)

export default component.exports